import React, { ReactNode } from 'react';

interface RatesSectionProps {
  children: ReactNode;
  borderColor?: string;
}

function RatesSection({
  children,
  borderColor = '#00AEEF',
}: RatesSectionProps) {
  return (
    <div className="border-t-[4px]" style={{ borderColor }}>
      {children}
    </div>
  );
}

export default RatesSection;
